import { User } from "lucide-react";
import { getPeople } from "@/lib/api";

const peopleProvider = {
  id: "personas",
  label: "Personas",
  icon: User,
  iconBg: "bg-blue-50",
  iconColor: "text-blue-600",
  fields: ["name", "phone", "email", "address"],
  load: (districtId) => getPeople({ district_id: districtId }),
  buildItem: (p) => ({
    id: p.id,
    title: p.name,
    subtitle: p.phone || "Persona",
    route: `/people/${p.id}`,
    recent: { id: p.id, type: "person", title: p.name, subtitle: p.phone || "Persona", route: `/people/${p.id}` },
  }),
};

export default peopleProvider;
